module.exports = __webpack_public_path__ + "img/vip_sign_gray.ef992b26.svg";